import Vue from "vue"
import store from "@/store"

const numpad = new Vue({
  data: {
    timeout: null,
    value: "",
    doit: () => {
      const channel = store.getters["live/allChannels"].find(channel => channel.sort === ("00" + numpad.value).slice(-3))
      numpad.value = ""
      if (!channel) return
      store.commit("live/category", null)
      store.commit("live/channel", channel)
      if (this_.$route.name !== "live") __.platform.go("/live/all/osd")
    }
  }
})

const Channel = {
  install(Vue) {
    Vue.prototype.$numpad = numpad
    Vue.prototype.$channelSelectWithNumber = function(event, timeout = 1000) {
      let value_ = event?.detail?.value
      if (value_ === null || value_ === undefined) return false

      if (/^\d+$/.test(value_)) {
        if (numpad.value.length === 3) return
        if (numpad.timeout) _$.removeTimeout(numpad.timeout)
        numpad.value += value_.toString()
        if (!timeout) return

        numpad.timeout = _$.makeTimeout(() => numpad.doit(), timeout)
      } else if (value_ === "delete") numpad.value = numpad.value.slice(0, -1)
      else numpad.doit()
    }
    Vue.prototype.$channelInstantWithID = function(id) {
      const channel = store.getters["live/allChannels"].find(channel => channel.id == id)
      numpad.value = ""
      if (!channel) return
      store.commit("live/category", null)
      store.commit("live/channel", channel)
      if (this_.$route.name !== "live") __.platform.go("/live/all/osd")
    }
  }
}

export default Channel
